var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-group row mt-3" },
    [
      _c("label-control", {
        staticClass: "col-xs-12 col-sm-5 col-form-label",
        attrs: {
          title: _vm.$attrs.title,
          instructionKey: _vm.$attrs.instructionsKey,
          required: _vm.$attrs.required,
          useTabindex: _vm.$attrs.useTabindex,
          titleParams: _vm.$attrs.titleParams,
          forElement: _vm.id
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-xs-6 col-sm-3 col-md-2 form-row-content" },
        [
          _c("numeric-input-control", {
            staticClass: "form-control",
            attrs: {
              id: _vm.id,
              placeholderKey: "EnterValue",
              required: _vm.$attrs.required,
              maxValue: _vm.$attrs.maxValue,
              minValue: _vm.$attrs.minValue,
              disabled: _vm.$attrs.disabled,
              rules: _vm.rules,
              formatting: _vm.formatting
            },
            model: {
              value: _vm.modifiedValue,
              callback: function($$v) {
                _vm.modifiedValue = _vm._n($$v)
              },
              expression: "modifiedValue"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }